export default __webpack_public_path__ + "static/media/CWSM.733f9280.png";